import { createContext } from 'react';
import type { ClientsManagementType } from './types';

const ClientsManagement = createContext<ClientsManagementType>(
  {} as ClientsManagementType,
);

export default ClientsManagement;
